import { StyleSheet, View, TouchableOpacity } from "react-native";
import React from "react";
import Text from "@components/CustomText";
import color from "@constants/color";

const ReconTabBtn = ({ rto, pending, selectedTab, setSelectedTab }) => {
  return (
    <View style={styles.container}>
      <TouchableOpacity
        testID="recon-rto-tab-btn"
        activeOpacity={0.8}
        onPress={() => setSelectedTab("rto")}
        style={[
          styles.tabContainer,
          {
            backgroundColor:
              selectedTab === "rto" ? color.mediumBlack : color.white,
          },
        ]}
      >
        <Text
          variant="body_text_2"
          style={[
            styles.tabText,
            {
              color: selectedTab === "rto" ? color.white : color.mediumBlack,
            },
          ]}
        >
          {`RTO (${rto})`}
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        testID="recon-pending-tab-btn"
        onPress={() => setSelectedTab("pending")}
        activeOpacity={0.8}
        style={[
          styles.tabContainer,
          {
            backgroundColor:
              selectedTab === "pending" ? color.mediumBlack : color.white,
          },
        ]}
      >
        <Text
          variant="body_text_2"
          style={[
            styles.tabText,
            {
              color:
                selectedTab === "pending" ? color.white : color.mediumBlack,
            },
          ]}
        >
          {`Pending (${pending})`}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  tabContainer: {
    borderRadius: 30,
    backgroundColor: color.white,
    padding: 12,
    borderColor: color.lighterBlack,
    borderWidth: 1,
    marginVertical: 12,
    width: "48%",
  },
  tabText: {
    textAlign: "center",
  },
});

export default ReconTabBtn;
